var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAlert = function SvgIconAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0.0830078C4.74701 0.0830078 0.083313 4.74671 0.083313 10.4997C0.083313 16.2526 4.74701 20.9163 10.5 20.9163C16.2529 20.9163 20.9166 16.2526 20.9166 10.4997C20.9166 7.737 19.8192 5.08748 17.8657 3.13398C15.9122 1.18047 13.2627 0.0830078 10.5 0.0830078ZM11.5416 14.1455C11.5416 14.4332 11.3085 14.6664 11.0208 14.6664H9.97915C9.6915 14.6664 9.45831 14.4332 9.45831 14.1455V11.0205C9.45831 10.7329 9.6915 10.4997 9.97915 10.4997H11.0208C11.3085 10.4997 11.5416 10.7329 11.5416 11.0205V14.1455ZM11.5416 7.89551C11.5416 8.18316 11.3085 8.41634 11.0208 8.41634H9.97915C9.6915 8.41634 9.45831 8.18316 9.45831 7.89551V6.85384C9.45831 6.56619 9.6915 6.33301 9.97915 6.33301H11.0208C11.3085 6.33301 11.5416 6.56619 11.5416 6.85384V7.89551Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconAlert.b8b73ca7.svg";
export { ForwardRef as ReactComponent };